<template >
  <div class="row" style="padding-top:3rem">
    <div class="eventos-map card" v-if="showGoogleMap">
      <div class="header">Visão geral no mapa</div>
      <google-maps
        :eventsSpecifications="eventsSpecifications"
        :trgMarkerCoordinates="events"
        :tags="listTags"
        :eduMarkerCoodinates="speeches"></google-maps>
    </div>
  </div>
</template>

<script>
import GoogleMaps from 'src/components/googleMaps.vue'
import FiltersMap from 'src/components/FiltersMap.vue'
import { apiEduService } from 'src/services/ApiEducacional.js'
import axios from 'axios'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'show-map',
  components: {
    GoogleMaps,
    FiltersMap
  },
  data () {
    return {
      load: false,
      eventId: '',
      eventsList: [],
      listSpeeches: [],
      userId: '',
      showMode: 'true', // onde 1 representa a visão dos eventos no mapa e 0 a visão das pesquisas,,
      showGoogleMap: false
    }
  },
  props: {
    allTags: Array
  },
  watch: {
    dateRange: function (current) {
      this.getAllSpeeches(this.dateRange, this.tags)
    },
    tags: function (current) {
      this.getAllSpeeches(this.dateRange, this.tags)
    }
  },
  mounted () {
    this.fetchAll({
      'where': [ { role: { '$ne': 'superadmin' } } ] // Codeseven não deve ser exibido
    })
    this.getAllSpeeches(this.dateRange)
    axios({
      method: 'get',
      url: 'https://couch-trg.3e.eng.br/'
    })
    .then(() => (this.showGoogleMap = true))
    .catch((e) => (this.showGoogleMap = false))
  },
  computed: {
    ...mapGetters('users', {
      user: 'selected'
    }),

    ...mapGetters({
      dateRange: 'rangeDate'
    }),

    ...mapGetters('tags', {
      tags: 'selecteds'
    }),

    ...mapGetters('events', {
      events: 'events',
      eventsOptions: 'optionsById'
    }),

    ...mapGetters('eventsSpecifications', {
      eventsSpecifications: 'withGpsEventsSpecifications'
    }),

    ...mapGetters('surveys', {
      surveys: 'surveys'
    }),

    listTags () {
      return this.allTags
    },

    speeches () {
      if (this.listSpeeches.length > 0) {
        return this.listSpeeches.filter(item => {
          if (item.gps.lat && item.gps.lng) {
            return true
          }
          return false
        })
      }
    }
  },
  methods: {
    ...mapActions('events', {
      fetchEventsWithSurveys: 'fetchEventsWithSurveys',
      fetchEvent: 'fetchOne'
    }),
    ...mapActions('users', {
      fetchAll: 'fetchAll'
    }),
    getAllSpeeches (dateRange, tags) {
      dateRange = this.formatDate(dateRange)
      if (tags) {
        tags = Object.values(tags).reduce((accumulate, current) => {
          for (let c of current) {
            if (accumulate.indexOf(c) === -1) accumulate.push(c)
          }
          return accumulate
        }, [])
      }
      apiEduService.getAll(dateRange, tags).then(res => {
        this.listSpeeches = res
      })
      .catch(err => console.log(err))
    },
    formatDate (arr) {
      if (arr.length !== 0) {
        return arr.map(item => {
          return item.substr(0, 10)
        })
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/showMap.vue